import script from "./ChangeGrade.vue?vue&type=script&setup=true&lang=js"
export * from "./ChangeGrade.vue?vue&type=script&setup=true&lang=js"

import "./ChangeGrade.vue?vue&type=style&index=0&id=41728c18&lang=scss"

const __exports__ = script;

export default __exports__